import Vue from 'Vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

const state = {
	sex: '',
	prov: '',
	city: '',
	year: '',
	month: '',
	day: '',
	height: '',
	money: '',
	marry: ''
}

const mutations={
	getSex(state,date) {
		state.sex = date;
	},
	getProv(state,date) {
		state.prov = date;
	},
	getCity(state,date) {
		state.city = date;
	},
	getYear(state,date){
		state.year = date;
	},
	getMonth(state,date){
		state.month = date;
	},
	getDay(state,data){
		state.day = data;
	},
	getHeight(state,data) {
		state.height = data;
	},
	getMoney(state,data) {
		state.money = data;
	},
	getMarry(state,data) {
		state.marry = data;
	}
}

export default new Vuex.Store({
	state,mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js